export default __webpack_public_path__ + "static/media/ariya_banner.31981f2b.jpeg";